import { wizardSteps } from '@/enums';

export default class RouterController {
  constructor({
    step, vacancy, wizardState,
  }) {
    this.vacancy = vacancy;
    this.wizardState = { ...wizardState || vacancy?.wizardState || {} };
    if (step) {
      this.wizardState.step = step;
    }
  }

  stepNumber = 1;

  initRoutes() {
    this.routes = [
      {
        name: 'vacancy-preset',
        step: wizardSteps.PRESET,
        params: [
          'vacancyId',
        ],
        stepNumber: 2,
        nextHandler: () => {
          return this.makeRoute({
            step: wizardSteps.COMMON,
            overloadParams: { index: 0 },
          });
        },
      },
      {
        name: 'vacancy-wizard',
        step: wizardSteps.COMMON,
        params: [
          'vacancyId',
          'interviewerId',
          'index',
        ],
        stepNumber: 3,
        backHandler: () => {
          if (this.wizardState.index === 0) {
            return this.makeRoute({
              step: this.wizardState.prevStep || wizardSteps.PRESET,
            });
          }
          const prevIndex = this.wizardState.index - 1;
          return this.makeRoute({
            step: wizardSteps.COMMON,
            overloadParams: { index: prevIndex },
          });
        },
        nextHandler: ({ count }) => {
          if (this.wizardState.index === count - 1) {
            return this.makeRoute({ step: wizardSteps.SPECIAL });
          }
          const nextIndex = this.wizardState.index + 1;
          return this.makeRoute({
            step: wizardSteps.COMMON,
            overloadParams: { index: nextIndex },
          });
        },
      },
      {
        name: 'vacancy-wizard-category',
        step: wizardSteps.CATEGORY,
        stepNumber: 3,
        params: [
          'vacancyId',
          'interviewerId',
          'categoryId',
          'index',
        ],
        backHandler: () => {
          this.stepNumber = 2;
          return this.makeRoute({ step: wizardSteps.COMMON });
        },
        nextHandler: () => {
          this.stepNumber = 4;
          return this.makeRoute({ step: wizardSteps.COMMON });
        },
      },
      {
        name: 'vacancy-wizard-special',
        step: wizardSteps.SPECIAL,
        stepNumber: 3,
        params: [
          'vacancyId',
          'interviewerId',
        ],
        backHandler: () => {
          this.stepNumber = 3;
          return this.makeRoute({
            step: wizardSteps.COMMON,
          });
        },
        nextHandler: () => {
          this.stepNumber = 4;
          return this.makeRoute({ step: wizardSteps.TESTING });
        },
      },
      {
        name: 'vacancy-questions',
        step: wizardSteps.QUESTIONS,
        stepNumber: 4,
        params: [
          'vacancyId',
          'interviewerId',
        ],
        backHandler: () => {
          const isPrevStep = this.wizardState.prevStep && this.wizardState.prevStep !== wizardSteps.QUESTIONS;
          const step = isPrevStep ? this.wizardState.prevStep : wizardSteps.SPECIAL;
          return this.makeRoute({ step });
        },
        nextHandler: () => {
          if (this.isVacancyExternal()) {
            return this.makeRoute({ step: wizardSteps.INTEGRATION });
          }
          return this.makeRoute({ step: wizardSteps.TESTING });
        },
      },
      {
        name: 'vacancy-ai-questions',
        step: wizardSteps.AI_QUESTIONS,
        stepNumber: 2,
        params: [
          'vacancyId',
          'interviewerId',
        ],
        backHandler: () => {
          const isPrevStep = this.wizardState.prevStep && this.wizardState.prevStep !== wizardSteps.QUESTIONS;
          const step = isPrevStep ? this.wizardState.prevStep : wizardSteps.PRESET;
          return this.makeRoute({ step });
        },
        nextHandler: () => {
          if (this.isVacancyExternal()) {
            return this.makeRoute({ step: wizardSteps.INTEGRATION });
          }
          return this.makeRoute({ step: wizardSteps.TESTING });
        },
      },
      {
        name: 'vacancy-invite-method',
        step: wizardSteps.INTEGRATION,
        stepNumber: 5,
        params: [
          'vacancyId',
        ],
        backHandler: () => {
          return this.makeRoute({ step: wizardSteps.QUESTIONS });
        },
        nextHandler: () => {
          return this.makeRoute({ step: wizardSteps.TESTING });
        },
      },
      {
        name: 'vacancy-testing',
        step: wizardSteps.TESTING,
        stepNumber: 3,
        params: [
          'vacancyId',
        ],
        backHandler: () => {
          // const isPrevStep = this.wizardState.prevStep && this.wizardState.prevStep !== wizardSteps.QUESTIONS;
          const step = (this.vacancy?.wizardState.isAiInterviewer || this.vacancy.hasAiQuestions)
            ? wizardSteps.AI_QUESTIONS
            : wizardSteps.QUESTIONS;
          return this.makeRoute({ step });
        },
        nextHandler: () => {
          return this.makeRoute({ step: wizardSteps.PUBLISH });
        },
      },
      {
        name: 'vacancy-faq',
        step: wizardSteps.FAQ,
        stepNumber: 4,
        params: [
          'vacancyId',
        ],
        backHandler: () => {
          if (this.isVacancyExternal()) {
            return this.makeRoute({ step: wizardSteps.QUESTIONS });
          }
          return this.makeRoute({ step: wizardSteps.TESTING });
        },
        nextHandler: () => {
          return this.makeRoute({ step: wizardSteps.PUBLISH });
        },
      },
      {
        name: 'vacancy-publish',
        step: wizardSteps.PUBLISH,
        stepNumber: 4,
        params: [
          'vacancyId',
        ],
        backHandler: () => {
          return this.makeRoute({ step: wizardSteps.TESTING });
        },
      },
    ];
  }

  isVacancyExternal() {
    // Проверяем только интеграцию с Работа.ру, не HeadHunter
    // Если есть hasHhIntegration, значит это HeadHunter, пропускаем шаг интеграции
    if (this.vacancy?.hasHhIntegration) {
      return false;
    }
    // Проверяем наличие внешних вакансий (Работа.ру)
    return this.vacancy?.externalVacancies?.length > 0;
  }

  makeNextRoute(params) {
    const route = this.findRoute(this.wizardState.step);
    if (typeof route.nextHandler === 'function') {
      return route.nextHandler(params);
    }
  }

  makePrevRoute(params) {
    const route = this.findRoute(this.wizardState.step);
    if (typeof route.backHandler === 'function') {
      return route.backHandler(params);
    }
  }

  next(router, params) {
    const nextRoute = this.makeNextRoute(params);
    if (nextRoute) {
      router.push(nextRoute);
    }
  }

  prev(router, params) {
    const prevRoute = this.makePrevRoute(params);
    if (prevRoute) {
      router.push(prevRoute);
    }
  }

  makeRoute({ step, wizardState, overloadParams = {} }) {
    if (!step) {
      return;
    }
    const route = this.findRoute(step);
    if (route) {
      const params = {};
      route.params.forEach((p) => {
        params[p] = (wizardState || this.wizardState)[p];
      });
      return {
        name: route.name,
        params: { ...params, ...overloadParams },
      };
    }
  }

  findRoute(step) {
    return this.routes?.find((r) => r.step === step);
  }
}
